<template>
<div style="overflow: hidden; padding-top: 100px; padding-bottom: 250px" >
    
    <b-row class="m-0 justify-content-center">
      <div  style="width: 1700px; max-width: 90%">
        <b-row class="m-0 justify-content-center mt-4">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 95%" >
            <div class="showcase-header py-4 linear-primary text-white" style="position: relative">
              <h4 class="text-center m-0">Tischbelegung</h4>
            </div>
            <b-row class="m-0" v-if="company">
              <div class="shadow p-3 m-2 mt-4 rounded bg-white" style="width: 23%" v-for="(i) in tables" :key="i.index">
                <div class="showcase-header py-2  text-white" :class="i.blocked ? i.visitor_group.orders.find(order => order._id.status != 'abgeschlossen') ? 'linear-danger pulse' : 'linear-success' : 'linear-warning text-dark' " style="position: relative">
                  <h5 class="m-0 text-center">Tisch {{ i.number }} </h5>
                </div>
                <b-row class="m-0 mt-3 justify-content-center">
                  <div v-if="i.blocked">
                    <p class="m-0 text-success">Gäste anwesend</p>
                  </div>
                  <div v-else>
                    <p class="m-0 text-danger">Keine Gäste</p>
                  </div>
                </b-row>
                <p class="m-0 mt-3 text-center">Tischcode:</p>
                <b-row class="m-0 mt-1 justify-content-center" v-if="company">
                  <qrcode-vue class="hover"  :value="'https://eatdorado.de/inhouse/' + company._id + '?tableId=' + i._id" :size="size" level="L" ></qrcode-vue>
                </b-row>
                <b-row class="m-0 mt-3 justify-content-center" v-if="!company.active && !i.blocked">
                  <b-button variant="danger" size="sm" @click="$store.dispatch('deleteTable', {_id: i._id})">Tisch löschen</b-button>
                </b-row>
                <b-row class="m-0 mt-3 justify-content-center" v-if="i.blocked">
                  <b-button variant="primary" size="sm" @click="$store.dispatch('blockTable', {_id: i._id, blocked: false})">Bestellung abschließen</b-button>
                </b-row>
              </div>

              <div v-if="company">
                <div v-if="!company.active" class="shadow p-3 m-2 rounded bg-white hover-table border border-success" style="min-height: 200px; position: relative; border-style: dashed !important; width: 23%; min-width: 200px" @click="postTable()">
                  <h5 class="text-center">Tisch hinzufügen</h5>
                  <b-row class="m-0 mt-3 center justify-content-center">
                    <font-awesome-icon class="mx-1 text-success h2 text-center" icon="plus" />
                  </b-row>
                </div>
              </div>
              

            </b-row>
          </div>
        </b-row>

        <div  class="d-lg-none showcase-invert bg-white shadow mx-2 mb-2 mt-5"  style="min-width: 95%" v-if="order">
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative; cursor: pointer" @click="$router.push('/orders').catch(err => {})">
            <h4 class="text-center m-0">Bestellung vom: {{ order.created | moment('DD.MM.YYYY HH:mm')}}</h4>
          </div>

            <div v-if="order">
              <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellnummer:</h5>
                <h5 class="m-0">{{order.ordernumber}}</h5>
              </b-row>
               <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellzeit:</h5>
                <h5 class="m-0">{{order.created | moment('DD.MM.YYYY HH:mm')}}</h5>
              </b-row>
              <b-row class="m-0 my-2  justify-content-between">
                <h5 class="m-0">Besteller:</h5>
                <h5 class="m-0">Tisch {{order.table.number}}</h5>
              </b-row>
              <div>
                <div class="my-2" v-for="item in order.items" :key="item.index">
                    <b-row class="m-0 justify-content-between" >
                      <h5 class="m-0">{{ item._id.title }}</h5>
                      <h5 class="m-0">x {{ item.amount }}</h5>
                    </b-row>
                    <b-row class="m-0 justify-content-between" v-if="item.note">
                      <p class="m-0">Hinweis: {{ item.note }}</p>
                    </b-row>
                    <b-row class="m-0 mt-1 justify-content-between" v-if="item.extras">
                      <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                        <p v-if="extra.choosen" class="m-0">{{ extra.title }}</p>
                      </div>
                    </b-row>
                    <hr>
                  </div>
              </div>
              
              <b-row class="m-0 mt-3 justify-content-between">
                <h5 class="m-0">Rechnungsbetrag:</h5>
              <h5 class="m-0">{{getTotalPrice(order)}}</h5>
              </b-row>
              <b-row class="m-0 mt-3 justify-content-between">
                <b-button block variant="warning" v-if="order.status == 'bestellt'" @click="updateOrder('bestätigt')">Bestellung bestätigen</b-button>
                <b-button block variant="info" v-if="order.status == 'bestätigt'" @click="updateOrder('bereit')">Bestellung ist abholbereit</b-button>
                <b-button block variant="success" v-if="order.status == 'bereit'" @click="updateOrder('abgeholt')">Bestellung wurde abgeholt</b-button>
                <b-button block variant="success" disabled v-if="order.status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
              </b-row>
            </div>

        </div>

        <b-row class="m-0 justify-content-center mt-4" v-if="inHouseOrders">
          <div  class="showcase-invert bg-white shadow m-2 mt-3"  style="min-width: 95%" >
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative">
            <h4 class="text-center m-0">InHouse-Bestellungen verwalten</h4>
          </div>
          <div v-if="inHouseOrders.length > 0">
          <b-table @row-clicked="setOrder" borderless :fields="fields" :items="inHouseOrders" striped responsive :per-page="10"
                :current-page="currentPageOrders">
        
            <template v-slot:head()="data">
              <p class="text-center text-dark" >{{ data.label.toUpperCase() }}</p>
            </template>

            <template v-slot:cell(created)="data">
              <p class="text-center my-2 text-dark" >{{data.item.created | moment('DD.MM.YYYY HH:mm')}}</p>
            </template>

            <template v-slot:cell(number)="data">
              <div v-if="data.item.table">
                <p class="text-center my-2 text-dark" >{{'Tisch ' + data.item.table.number}}</p>
              </div>
              
            </template>

            <template v-slot:cell(status)="data">
              <p class="text-center my-2 text-dark" ><b-badge :variant="getBadgeVariant(data.item.status)">{{data.item.status}}</b-badge></p>
            </template>

            <template v-slot:cell(ordernumber)="data">
              <p class="text-center my-2 text-dark" >{{data.item.ordernumber}}</p>
            </template>

            <template v-slot:cell(price)="data">
              <p class="text-center my-2 text-dark" >{{ getTotalPrice(data.item) }}</p>
            </template>
          
          </b-table>
          <nav class="mt-4">
            <b-pagination size="sm" :total-rows="inHouseOrders.length" :per-page="10" v-model="currentPageOrders" prev-text="letzte" next-text="nächste" hide-goto-end-buttons/>
          </nav>

          <div  class="d-none d-lg-block showcase-invert bg-white shadow mx-2 mb-2 mt-5"  style="min-width: 95%" v-if="order">
          <div class="showcase-header py-4 linear-primary text-white" style="position: relative; cursor: pointer" @click="$router.push('/orders').catch(err => {})">
            <h4 class="text-center m-0">Bestellung vom: {{ order.created | moment('DD.MM.YYYY HH:mm')}}</h4>
          </div>

            <div v-if="order">
               <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellnummer:</h5>
                <h5 class="m-0">{{order.ordernumber}}</h5>
              </b-row>
               <b-row class="m-0 my-2 justify-content-between">
                <h5 class="m-0">Bestellzeit:</h5>
                <h5 class="m-0">{{order.created | moment('DD.MM.YYYY HH:mm')}}</h5>
              </b-row>
              <b-row class="m-0 my-2 mb-4 justify-content-between">
                <h5 class="m-0">Besteller:</h5>
                <h5 class="m-0">Tisch {{order.table.number}}</h5>
              </b-row>
              <div>
                <div class="my-2" v-for="item in order.items" :key="item.index">
                    <b-row class="m-0 justify-content-between" >
                      <h5 class="m-0">{{ item._id.title }}</h5>
                      <h5 class="m-0">x {{ item.amount }}</h5>
                    </b-row>
                    <b-row class="m-0 justify-content-between" v-if="item.note">
                      <p class="m-0">Hinweis: {{ item.note }}</p>
                    </b-row>
                    <u><p class="m-0 mt-2">Beilagen / Extras:</p></u>
                    <b-row class="m-0  justify-content-between" v-if="item.extras">
                      <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                        <p v-if="extra.choosen" class="m-0">{{ extra.title }}</p>
                      </div>
                    </b-row>
                    <u><p class="m-0 mt-2">Variante(n):</p></u>
                    <b-row class="m-0 mt-1 justify-content-between" v-if="item.variants">
                      <div v-for="variant in item.variants" class="w-100" :key="variant.index">
                        <p v-if="variant.choosen" class="m-0">{{ variant.choosen.title }}</p>
                      </div>
                    </b-row>
                    <hr>
                  </div>
              </div>

              
              
              <b-row class="m-0 mt-3 justify-content-between">
                <h5 class="m-0">Rechnungsbetrag:</h5>
              <h5 class="m-0">{{getTotalPrice(order)}}</h5>
              </b-row>
              <b-row class="m-0 mt-3 justify-content-between">
                <b-button block variant="warning" v-if="order.status == 'bestellt'" @click="updateOrder('abgeschlossen')">Bestellung abschließen</b-button>
              </b-row>
            </div>

        </div>

          </div>
          <b-row class="m-0 my-3 justify-content-center" v-else>
            <div>
              <b-row class="m-0 my-3 justify-content-center">
                <b-img  :src="require(`@/assets/images/undraw_completed.svg`)" style="width: 200px; height: 200px" fluid alt="eatDorado Logo"></b-img>
              </b-row>
              <h3 class="text-center">Keine Bestellungen vorhanden</h3>
            </div>
          </b-row>
          </div>
        </b-row>

      </div>
    </b-row>
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'InHouse',
  mixins: [coreData],
  components: {
    QrcodeVue
  }, 
  data: () => {
    return {
      size: 100,
      currentPageOrders: 1,
      order: null,
      fields: [
        { key: 'created', label: 'Bestellzeit' },
        { key: 'number', label: 'Tisch', sortable: true },
        { key: 'price', label: 'Preis', sortable: true },
        { key: 'ordernumber', label: 'Bestellnummer', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
      ],
      departmentForm: {},
      newDepartment: false
    }
  },
  watch: {
    inHouseOrders(){
       if(this.inHouseOrders && !this.order){
        var query = this.inHouseOrders.find(el => el._id == this.$route.query.id)
        if(query) return this.order = query
      }
    }
    
  },
  computed: {
    week(){
      if(this.kw){
        return {year: this.kw[0], week: this.kw[1], month: this.kw[2]}
      }
      return null
    },
  },
  mounted(){
    this.refreshData();
    this.$store.dispatch('tryAutoLogin')
    console.log(this.$route)
    if(this.inHouseOrders && !this.order){
      var query = this.inHouseOrders.find(el => el._id == this.$route.query.id)
      if(query) return this.order = query
    }
  },
  methods: {
    postTable(){
      
      var payload = {}
      
      if(this.tables.length > 0){
        payload = {number: this.tables[this.tables.length - 1].number + 1}
        console.log(this.tables[this.tables.length - 1].number + 1)
      }else{
        payload = {number: 1}
      }
      console.log(payload)
      this.$store.dispatch('postTable', payload)
    },
    setOrder(record){
      this.order = record
    },
    updateOrder(status){
      const payload = {
        _id: this.order._id,
        data: {
          status: status
        }
      }
      this.order.status = status
      this.$store.dispatch('updateInHouseOrders', payload)
    },

    postDepartment(){
      var street = this.departmentForm.street
      var zipcode = this.departmentForm.zipcode
      var city = this.departmentForm.city
      var country = this.departmentForm.country
      var state = this.departmentForm.state

      if(!street){
        street = this.company.adress.street
      }

      if(!zipcode){
        zipcode = this.company.adress.zipcode
      }

      if(!city){
        city = this.company.adress.city
      }

      if(!country){
        country = this.company.adress.country._id
      }

      if(!state){
        state = this.company.adress.state._id
      }

      const payload = {
        company: this.company._id,
        title: this.departmentForm.title,
        adress: {
          street: street,
          zipcode: zipcode,
          city: city,
          country: country,
          state: state
        }
      }

      this.$store.dispatch('postDepartment', payload)
    }
  }
}
</script>

<style lang="scss" scoped>

  .hover-table {
    cursor: pointer;

    &:hover {
        color: #fff !important;
        background-color: #28a745 !important;

        path {
          color: #fff !important;
        }
    }
    
  }

</style>